import { SyncEvent } from '../Event/SyncEvent';
import { AbstractService } from '../Service/AbstractService';
import { NotificationServiceEvent } from './NotificationServiceEvent';
import { NotificationPayload } from '@standardnotes/domain-core';
import { WebSocketsServiceEvent } from '../Api/WebSocketsServiceEvent';
export class NotificationService extends AbstractService {
    constructor(internalEventBus) {
        super(internalEventBus);
        this.handledNotifications = new Set();
    }
    async handleEvent(event) {
        switch (event.type) {
            case SyncEvent.ReceivedNotifications:
                return this.handleReceivedNotifications(event.payload);
            case WebSocketsServiceEvent.NotificationAddedForUser:
                return this.handleReceivedNotifications([event.payload.notification]);
            default:
                break;
        }
    }
    async handleReceivedNotifications(notifications) {
        if (notifications.length === 0) {
            return;
        }
        for (const notification of notifications) {
            if (this.handledNotifications.has(notification.uuid)) {
                continue;
            }
            this.handledNotifications.add(notification.uuid);
            const eventPayloadOrError = NotificationPayload.createFromString(notification.payload);
            if (eventPayloadOrError.isFailed()) {
                continue;
            }
            const payload = eventPayloadOrError.getValue();
            const serviceEvent = { eventPayload: payload };
            await this.notifyEventSync(NotificationServiceEvent.NotificationReceived, serviceEvent);
        }
    }
}
